// extracted by mini-css-extract-plugin
module.exports = {"dialog":"alertDialog_dialog__2v_Rh","title":"alertDialog_title__3S6c3"};